import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import defaultMsg from '../src/translations/lang/en-US.json';

// Import Style
import './public/css/Footer.css';
class Footer extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const footer = invert => {
      const cls = invert
        ? 'olo-client-theme-color olo-client-theme-background-white '
        : 'olo-client-theme-background olo-client-theme-color-white ';
      return (
        <div>
          <div id="app-footer" className={`stickyFooter ${cls}`}>
            <p>
              &copy;
              {moment().format('YYYY')} &middot;&nbsp;
              <FormattedMessage
                id="poweredByLavu"
                defaultMessage={defaultMsg.poweredByLavu}
              />
            </p>
            <p>
              <a
                target="_blank"
                href="https://www.lavu.com/lavu-inc-privacy-policy"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="privacyPolicy"
                  defaultMessage={defaultMsg.privacyPolicy}
                />
              </a>
              &nbsp;|&nbsp;
              <a
                target="_blank"
                href="https://www.lavu.com/lavu-togo-terms-of-service"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="termsAndConditions"
                  defaultMessage={defaultMsg.termsAndConditions}
                />
              </a>
            </p>
          </div>
        </div>
      );
    };
    const { showOrderPanel } = this.props;
    return showOrderPanel ? (
      <div className="col-lg-9 col-md-9 col-sm-9">{footer(true)}</div>
    ) : (
      footer(false)
    );
  }
}

function mapStateToProps(state) {
  return {
    showOrderPanel: state.dashboard.showOrderPanel,
  };
}
export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/Footer.js